import axios from 'axios'

import { parseResponse, handleError } from '@/_helpers/utils.js'

const state = {
  loading: true,
  error: null,
  activities: [],
  pagination: {
    pageNumber: 1,
    totalPages: 1,
    load_more_pages: 1,
    is_load_more: false,
    count: 20
  },
  sorting: {
    name: null,
    order: 'asc'
  }
}

const actions = {
  fetch ({commit, state, dispatch}, filters) {
    commit('fetch')

    let recruiterId = filters.recruiterId
    filters.recruiterId = null

    let params = {}

    Object.keys(filters)
      .filter(key => !filters[key] || !filters[key].id || (filters[key].id !== 'all')) // check if no id or id is not 'all'
      .forEach(key => {
        if (filters[key] && filters[key].id) {
          Object.assign(params, {
            [ `${key}_id` ]: filters[key].id
          })
        } else {
          Object.assign(params, {
            [ key ]: filters[key]
          })
        }
      })

    params.page = state.pagination.pageNumber
    params.count = state.pagination.count

    const sorting = state.sorting

    if (sorting.name) {
      Object.assign(params, {
        sort_by: sorting.name,
        sort_order: sorting.order
      })
    }

    let count = state.pagination.count;

    const is_load_more = state.pagination.is_load_more;

    if (is_load_more) {
      count = (state.pagination.pageNumber * state.activities.length) + state.pagination.count

      params.page = 1;
      params.count = count
    } else {
      params.page = state.pagination.pageNumber
      params.count = state.pagination.count
    }

    return axios.get(`/1.0/admin/recruiters/${recruiterId}/activity`, {params})
      .then(resp => {
        const response = parseResponse(resp)

        commit('fetchSuccess', {data: response.data, meta: response.meta, is_load_more})

        if (is_load_more) {
          commit('set_pagination_more', {count})
        }
      })
      .catch(err => {
        const error = handleError(err)

        dispatch('global/setError', error, {root: true})
        commit('fetchFailure', error)
      })
  },

  updateSorting ({ commit, state, dispatch }, data) {
    commit('resetPagination')
    commit('updateSorting', data)
    dispatch('fetch')
  }
}

const mutations = {
  fetch (state) {
    state.loading = true
  },

  fetchSuccess (state, {data, meta, is_load_more}) {
    if (!is_load_more) {
      state.pagination.totalPages = Math.ceil(meta.total / state.pagination.count)
    }
    state.activities = data
    state.loading = false
  },

  fetchFailure (state, err) {
    state.error = err
    state.loading = false
    console.error(err)
  },

  updatePagination (state, params) {
    state.pagination = Object.assign(state.pagination, params)
  },

  updateSorting (state, data) {
    Object.assign(state.sorting, data)
  },

  set_load_more (state, val) {
    state.pagination = Object.assign(state.pagination, {
      is_load_more: val
    })
  },

  resetPagination (state) {
    state.pagination = Object.assign({}, state.pagination, {
      pageNumber: 1,
      totalPages: 1,
      load_more_pages: 1,
      is_load_more: false,
      count: 20
    })
  },

  set_pagination_more (state, {count}) {
    state.pagination.load_more_pages = Math.ceil(count / state.pagination.count)
  },

  change_count (state, val) {
    state.pagination = Object.assign(state.pagination, {
      count: val,
      pageNumber: 1
    })
  }
}

const getters = {
  loading (state, getters) {
    return state.loading
  },

  list: (state, getters) => {
    return state.activities
  },

  pagination: (state, getters) => {
    return state.pagination
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
